import { UserX } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import type { HouseholdMember } from '@/types/household'

interface HouseholdMembersListProps {
  members: HouseholdMember[]
  currentUserId?: string
  currentUserDisplayName?: string
  isAdmin: boolean
  onRemoveMember: (memberId: string) => void
}

export function HouseholdMembersList({
  members,
  currentUserId,
  currentUserDisplayName,
  isAdmin,
  onRemoveMember,
}: HouseholdMembersListProps) {
  if (members.length === 0) {
    return null
  }

  return (
    <div>
      <h4 className="mb-2 text-sm font-medium">Leden</h4>
      <div className="space-y-2">
        {members.map((member) => (
          <div key={member.id} className="flex items-center justify-between rounded bg-gray-50 p-2">
            <div className="flex items-center gap-2">
              <div className="text-sm">
                <span className="font-medium">
                  {member.user_id === currentUserId
                    ? currentUserDisplayName || 'Jij'
                    : `Lid ${member.user_id.slice(0, 8)}`}
                </span>
                {member.user_id !== currentUserId && (
                  <span className="ml-1 text-gray-500">({member.user_id.slice(0, 8)})</span>
                )}
              </div>
              <Badge variant={member.role === 'admin' ? 'default' : 'outline'} className="text-xs">
                {member.role === 'admin' ? 'Admin' : 'Lid'}
              </Badge>
              {member.user_id === currentUserId && (
                <Badge variant="secondary" className="text-xs">
                  Jij
                </Badge>
              )}
            </div>

            {isAdmin && member.user_id !== currentUserId && (
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onRemoveMember(member.id)}
                className="text-red-600 hover:text-red-700"
              >
                <UserX className="h-4 w-4" />
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
